/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import DOMPurify from 'dompurify'

import type { ReactElement } from 'react'

export function sanitizeHtmlAsString(html: string) {
  return DOMPurify.sanitize(html, { ALLOWED_ATTR: ['class', 'href', 'target'] })
}

export default function sanitizeHtml(html: string): ReactElement<'span'> {
  const sanitized: string = sanitizeHtmlAsString(html)

  return <span dangerouslySetInnerHTML={{ __html: sanitized }} />
}
